const categories = [
  { label: "Denim", width: "82%", val: "₹4.2L", color: "#D47060" },
  { label: "Knitwear", width: "68%", val: "₹3.1L", color: "#C4975A" },
  { label: "Formals", width: "45%", val: "₹2.0L", color: "#C4975A" },
  { label: "Kidswear", width: "29%", val: "₹1.3L", color: "#6DB892" },
];

const stopBuying = [
  "Slim fit chinos (Navy)",
  "Polyester kurta sets",
  "Overcoat (Brown/XL)",
  "Printed palazzo (3-pack)",
  "Office shirts (White/M)",
];

export default function VisualInsights() {
  return (
    <div className="sm-insights">
      <div className="sm-insights-inner">
        <div className="sm-reveal">
          <span className="sm-eyebrow" style={{ color: "rgba(196,151,90,.8)" }}>
            Live Sample
          </span>
          <h2 className="sm-h2 sm-h2-dark">What Stock Move shows you</h2>
          <p className="sm-h2-sub sm-h2-sub-dark">
            Here's what a typical analysis looks like — based on a real store
            with ₹22L in inventory.
          </p>
        </div>

        <div className="sm-dashboard sm-reveal sm-reveal-d1">
          <div className="sm-db-header">
            <span className="sm-db-title">
              Stock Move — Inventory Health Report
            </span>
            <span className="sm-db-meta">
              Generated: April 2025 · 847 SKUs analysed
            </span>
          </div>

          <div className="sm-db-body">
            {[
              {
                label: "Dead Cash",
                val: "₹18.4L",
                sub: "Blocked in 89 products",
                badge: "High risk",
                badgeCls: "red",
              },
              {
                label: "Slow Movers",
                val: "142 SKUs",
                sub: "< 2 units / month",
                badge: "Monitor",
                badgeCls: "amber",
              },
              {
                label: "Avg Days Cover",
                val: "67 days",
                sub: "Healthy range: 30–45",
                badge: "Overstocked",
                badgeCls: "amber",
              },
              {
                label: "Clear Priority",
                val: "34 Products",
                sub: "Act in next 30 days",
                badge: "Immediate",
                badgeCls: "red",
              },
            ].map((metric, index) => (
              <div key={index} className="sm-db-metric">
                <div className="sm-db-m-label">{metric.label}</div>
                <div className="sm-db-m-val">{metric.val}</div>
                <div className="sm-db-m-sub">{metric.sub}</div>
                <span className={`sm-db-m-badge ${metric.badgeCls}`}>
                  {metric.badge}
                </span>
              </div>
            ))}
          </div>

          <div className="sm-db-lower">
            <div className="sm-db-card">
              <div className="sm-db-card-title">Dead Cash by Category</div>
              {categories.map((category, index) => (
                <div key={index} className="sm-db-bar-row">
                  <span className="sm-db-bar-label">{category.label}</span>
                  <div className="sm-db-bar-track">
                    <div
                      className="sm-db-bar-fill"
                      style={{
                        width: category.width,
                        background: category.color,
                      }}
                    />
                  </div>
                  <span className="sm-db-bar-val">{category.val}</span>
                </div>
              ))}
            </div>

            <div className="sm-db-card">
              <div className="sm-db-card-title">Stop Buying — Top 5 Products</div>
              {stopBuying.map((item, index) => (
                <div key={index} className="sm-db-list-item">
                  <span className="sm-db-list-name">{item}</span>
                  <span className="sm-db-list-badge">Stop Buying</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}